import { useQuery } from 'react-query';
import { getPreview, GetPreviewParams } from '../clients/productPreview';

export const useGetPreview = (props: GetPreviewParams) => {
  return useQuery<{ previewUrl: string | undefined }, Error>(['preview', props.documentReferenceUri], () =>
    getPreview(props),
  );
};
